import { HTTP_CP_MortgageCase } from '@api-new/caseservice';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MemoizedSelector } from '@ngrx/store/src/selector';
import { AppState } from '@shared/models/app-state.model';
import { mortgageCasesAdapter } from '@shared/store/mortgage-cases/mortgage-cases.reducer';
import { MortgageCasesState } from '@shared/store/mortgage-cases/mortgage-cases.state';

const { selectAll, selectEntities } = mortgageCasesAdapter.getSelectors();

export const selectMortgageCasesState = createFeatureSelector<MortgageCasesState>('mortgageCases');

export const selectMortgageCases = createSelector(selectMortgageCasesState, (mortgageCasesState: MortgageCasesState) =>
  selectAll(mortgageCasesState),
);

export const selectMortgageCaseEntities = createSelector(selectMortgageCasesState, (mortgageCasesState: MortgageCasesState) =>
  selectEntities(mortgageCasesState),
);

export const selectMortgageCase = (mortgageCaseId: string): MemoizedSelector<AppState, HTTP_CP_MortgageCase> =>
  createSelector(
    selectMortgageCaseEntities,
    (mortgageCaseEntities: Dictionary<HTTP_CP_MortgageCase>) => mortgageCaseEntities[mortgageCaseId] ?? null,
  );

export const selectIsLoadingMortgageCases = createSelector(
  selectMortgageCasesState,
  (mortgageCasesState: MortgageCasesState) => mortgageCasesState.loading,
);

export const selectHasMortgageCaseForMortgage = (mortgageId: string): MemoizedSelector<AppState, boolean> =>
  createSelector(selectMortgageCases, (mortgageCases) => mortgageCases.some((mortgageCase) => mortgageCase.mortgageId === mortgageId));
